module.exports = __webpack_public_path__ + "img/warn.40c92f67.png";